import { forwardRef } from 'react'

import styles from './Spinner.module.css'

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg'
  color?: 'primary' | 'secondary' | 'inherit'
}

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', color = 'primary', className, ...props }, ref) => {
    const classNames = [styles.spinner, styles[size], styles[color], className]
      .filter(Boolean)
      .join(' ')

    return (
      <div ref={ref} className={classNames} role="status" aria-label="Loading" {...props}>
        <span className={styles.visuallyHidden}>Loading...</span>
      </div>
    )
  }
)

Spinner.displayName = 'Spinner'
